"use client";

import Sidebar from "@/app/(pages)/(account)/account/_component/Sidebar";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";

export default function AccountLayoutContent({ children }: { children: React.ReactNode }) {
    const router = useRouter();
    const { status } = useSession();

    useEffect(() => {
        if (status === "unauthenticated") {
            router.replace("/auth/accedi");
        }
    }, [router, status]);

    if (status === "loading") {
        return <div className="min-h-[50vh]" />;
    }

    if (status === "unauthenticated") {
        return null;
    }

    return (
        <div className="flex w-full flex-col lg:flex-row">
            <Sidebar />
            <div className="flex-1">{children}</div>
        </div>
    );
}
